import request from '@/utils/request'
export function getAd(query) {
    return request({
        url: "/adInfo/list",
        method: "get",
        params: query,
    });
}

//   ?pageNum=1&pageSize=10&type=首页广告位6